var map = {
	"./add.svg": "4646",
	"./aim.svg": "fa0a",
	"./alarm.svg": "5c03",
	"./allow.svg": "e68b",
	"./angle-down.svg": "aa48",
	"./angle-left.svg": "ad6a",
	"./angle-right.svg": "b6d9",
	"./anticheat-circle.svg": "15ad",
	"./antichit-warning.svg": "b65f",
	"./arrow-down.svg": "5c3c",
	"./arrow-left.svg": "9ba7",
	"./arrow-right.svg": "966d1",
	"./arrow-up-right.svg": "985f",
	"./arrow-up.svg": "5200",
	"./attention.svg": "c7b2",
	"./berserk.svg": "8420",
	"./binocular.svg": "8990",
	"./bookmark.svg": "4e1b",
	"./bullit.svg": "94e0",
	"./calendar.svg": "557c",
	"./cam-circle.svg": "65e7",
	"./cam.svg": "8338",
	"./cells.svg": "9739",
	"./chart.svg": "b302",
	"./check-list.svg": "7837",
	"./checkmark-green-plain.svg": "bcbe",
	"./checkmark-green.svg": "f037",
	"./checkmark.svg": "5f63",
	"./close.svg": "6282",
	"./clothes.svg": "12e0",
	"./coins-gold.svg": "2018",
	"./coins-yellow.svg": "ce9c",
	"./coins.svg": "2cc5",
	"./copy.svg": "31c9",
	"./cost.svg": "3bfa",
	"./credit-card.svg": "19cc",
	"./crown.svg": "ac82",
	"./crown2.svg": "47a8",
	"./dashboard.svg": "5451",
	"./denied.svg": "193f",
	"./dislike.svg": "a408",
	"./dots.svg": "7b48",
	"./double-check.svg": "dc04",
	"./download.svg": "24a4",
	"./duration.svg": "874a",
	"./earth.svg": "3d83",
	"./edit.svg": "8399",
	"./email.svg": "a96b",
	"./euro.svg": "c267",
	"./exit.svg": "9efb",
	"./eye-closed.svg": "8e96",
	"./eye.svg": "45c2",
	"./filter-arrow.svg": "84e4",
	"./filter.svg": "8e90",
	"./fire.svg": "1519",
	"./fixed.svg": "40f6",
	"./flatten.svg": "f79c",
	"./gamepad.svg": "93bc",
	"./gamepad2.svg": "6594",
	"./gear.svg": "567a",
	"./gem.svg": "cb36",
	"./globe.svg": "22b8",
	"./google.svg": "905a",
	"./group.svg": "569b",
	"./halfstar.svg": "0731",
	"./heart.svg": "a36f",
	"./hourglass.svg": "b197",
	"./info.svg": "0c83",
	"./keyboard.svg": "3414",
	"./kill.svg": "9db9",
	"./link.svg": "7c12",
	"./list.svg": "dcef",
	"./lock-open.svg": "21e1",
	"./medal.svg": "c3e0",
	"./min-players.svg": "652a",
	"./money.svg": "37bb",
	"./my-account.svg": "139c",
	"./not-fixed.svg": "2285",
	"./notifications.svg": "7028",
	"./phone.svg": "9855",
	"./player-empty.svg": "1292",
	"./players.svg": "8741",
	"./plus.svg": "8c7a",
	"./prize.svg": "83da",
	"./protect.svg": "4cf9",
	"./qiwi.svg": "7377",
	"./question-mark.svg": "2a6f",
	"./rating.svg": "c0a3",
	"./referral.svg": "9e39",
	"./refresh.svg": "2178",
	"./reglament.svg": "137f",
	"./ruble.svg": "c542",
	"./sad.svg": "6f0c",
	"./sale.svg": "eb93",
	"./send.svg": "e128",
	"./shape.svg": "cd00",
	"./shield.svg": "3238",
	"./shop.svg": "ba03",
	"./sidebar.svg": "17da",
	"./sign-in.svg": "f985",
	"./smile.svg": "f3a0",
	"./star-with-paddings.svg": "f977",
	"./star.svg": "43a2",
	"./status.svg": "2803",
	"./store.svg": "f67e",
	"./success.svg": "17bf",
	"./target.svg": "1ca4",
	"./thunder-move.svg": "832c",
	"./thunder.svg": "44e4",
	"./ticket-big.svg": "708b",
	"./ticket.svg": "dcd9",
	"./time.svg": "18e2",
	"./timer.svg": "b676",
	"./trophy-1.svg": "2940",
	"./trophy.svg": "c987",
	"./up-down.svg": "eb79",
	"./user.svg": "7393",
	"./verified.svg": "116f",
	"./visible.svg": "62d8",
	"./wallet-header.svg": "e9ce",
	"./wallet.svg": "b653",
	"./warning.svg": "248b",
	"./webmoney.svg": "74f9",
	"./world.svg": "481a",
	"./x2.svg": "24ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";